import { APIService } from "@/config/api-service-client.js";

const PATH = (activeEntityID) => `/atu-entity/${activeEntityID}/profiles`;

const getDefaultState = () => {
  return {
    activeEntityProfilesList: [],
    activeEntityProfilesListParams: {
      pagination: {
        pageSize: 10,
        currentPage: 1,
      },
      searchText: "",
      tableSorting: {
        sortType: "",
        sortTypeOrder: "",
      },
    },
    activeEntityActiveProfile: null,
    entityProfileModalVissible: false,
  };
};

export default {
  state: getDefaultState(),
  getters: {
    getActiveEntityProfilesList: (state) => state.activeEntityProfilesList,
    getActiveEntityAcctiveProfiles: (state) => state.activeEntityActiveProfile,
  },
  actions: {
    async fetchEntityProfiles(ctx) {
      const entityID = ctx.getters.getActiveEntity.id;
      const params = ctx.state.activeEntityProfilesListParams;
      const sortType = params.tableSorting.sortType;
      const sortTypeOrder = params.tableSorting.sortTypeOrder;
      const page = params.pagination.currentPage - 1;
      const size = params.pagination.pageSize;
      const searchText = params.searchText;

      let path = `${PATH(
        entityID
      )}?sort=${sortType},${sortTypeOrder}&page=${page}&size=${size}`;
      if (searchText) {
        path = `${path}&key=${searchText}`;
      }

      try {
        const resp = await APIService.get(path);
        ctx.commit("MUTATE_ENTITY_PROFFILES", resp);
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    async createEntityProfile(ctx, form) {
      const entityID = ctx.getters.getActiveEntity.id;
      try {
        const resp = await APIService.post(`${PATH(entityID)}`, {
          ...form,
        });
        ctx.dispatch("fetchEntityProfiles");
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async editEntityProfile(ctx, data) {
      const entityID = ctx.getters.getActiveEntity.id;
      const { id, ...rest } = data;
      try {
        const resp = await APIService.put(`${PATH(entityID)}/${id}`, {
          ...rest,
        });
        ctx.dispatch("fetchEntityProfiles");
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async fetchEntityProfileByID(ctx, id) {
      const entityID = ctx.getters.getActiveEntity.id;
      try {
        const resp = await APIService.get(`${PATH(entityID)}/${id}`);
        ctx.commit("MUTATE_ACTIVE_ENTITY_ACTIVE_PROFILE", resp);
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async deleteEntityProfile(ctx, id) {
      const entityID = ctx.getters.getActiveEntity.id;
      try {
        await APIService.delete(`${PATH(entityID)}/${id}`);
        ctx.dispatch("fetchEntityProfiles");
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    async fetchCleanWebProfilesEXT(ctx, key) {
      const slot_name = ctx.getters.getActiveEntity.slot_name;
      let URL = `cws/profiles?slot_name=${slot_name}`;
      if (key) URL = `${URL}&key=${key}`;
      try {
        const resp = await APIService.get(URL);
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
  },
  mutations: {
    MUTATE_ENTITY_PROFFILES(state, payload) {
      state.activeEntityProfilesList = payload;
    },
    MUTATE_ACTIVE_ENTITY_ACTIVE_PROFILE(state, payload) {
      state.activeEntityActiveProfile = payload;
    },
    RESET_ENTITIY_PROFILES(state) {
      Object.assign(state, getDefaultState());
    },
  },
};
